export const PHONE = "(13) 99679-9241";
export const PHONE_TEL = "013996799241";
export const WA = "https://wa.me/5513996799241";
export const EMAIL = "contato@desentupidoralitoral.site";
export const ADDRESS = "R. das Maritacas, 831 — Maresias, São Sebastião - SP, CEP 11628-649";
export const CNPJ = "48.416.188/7085-73";

export const waLink = (msg) => `${WA}?text=${encodeURIComponent(msg)}`;

export const SERVICES = [
  {
    slug: "desentupimento-de-esgoto",
    name: "Desentupimento de Esgoto",
    desc: "Desobstrução completa de redes de esgoto com rotativas e hidrojato, sem quebra-quebra.",
    image: "/img/desentupimento-de-esgoto-litoral.png",
    alt: "Serviço profissional de desentupimento de esgoto residencial e comercial no litoral paulista"
  },
  {
    slug: "desentupimento-de-pia",
    name: "Desentupimento de Pia",
    desc: "Pias de cozinha e banheiro, sifões e ramais — remoção total de gordura e resíduos.",
    image: "/img/desentupimento-de-pia-cozinha-litoral.png",
    alt: "Desentupimento de pia de cozinha e sifão com remoção de gordura no litoral"
  },
  {
    slug: "desentupimento-de-vaso-sanitario",
    name: "Desentupimento de Vaso Sanitário",
    desc: "Desobstrução sem danificar a louça e sem remover a bacia na maioria dos casos.",
    image: "/img/desentupimento-de-vaso-sanitario-banheiro.png",
    alt: "Desobstrução de vaso sanitário entupido de forma limpa e rápida sem quebrar a louça"
  },
  {
    slug: "desentupimento-de-ralo",
    name: "Desentupimento de Ralo",
    desc: "Ralos internos, externos, garagem e piscina — especialistas em entupimento por areia.",
    image: "/img/desentupimento-de-ralo-banheiro-areia.png",
    alt: "Técnico limpando ralo entupido por areia de praia no litoral paulista"
  },
  {
    slug: "hidrojateamento",
    name: "Hidrojateamento",
    desc: "Jato de alta pressão que limpa 100% da tubulação: raízes, gordura e areia compactada.",
    image: "/img/hidrojateamento-litoral-sp.webp",
    alt: "Serviço de hidrojateamento de alta pressão para limpeza de tubulações de esgoto no litoral"
  },
  {
    slug: "limpeza-de-fossa",
    name: "Limpeza de Fossa",
    desc: "Esgotamento com caminhão a vácuo e descarte 100% licenciado, com certificado.",
    image: "/img/limpeza-de-fossa-litoral-sp.webp",
    alt: "Caminhão tanque de sucção a vácuo realizando a limpeza de fossa séptica"
  },
  {
    slug: "limpeza-de-caixa-de-gordura",
    name: "Limpeza de Caixa de Gordura",
    desc: "Residencial e comercial, com comprovante para a vigilância sanitária.",
    image: "/img/limpeza-de-caixa-de-gordura-restaurante.png",
    alt: "Limpeza de caixa de gordura em restaurante ou residência com remoção de gordura pastosa"
  },
  {
    slug: "succao-de-residuos",
    name: "Sucção de Resíduos",
    desc: "Sucção a vácuo de fossas, poços, galerias, subsolos alagados e tanques.",
    image: "/img/succao-de-residuos-caminhao-vacuo.png",
    alt: "Caminhão auto vácuo de alta potência realizando sucção de resíduos e efluentes"
  },
  {
    slug: "atendimento-residencial",
    name: "Atendimento Residencial",
    desc: "Casas, apartamentos e imóveis de temporada — com check-up pré-temporada.",
    image: "/img/tecnico-desentupimento-residencial-litoral.webp",
    alt: "Técnico encanador realizando atendimento de desentupimento residencial em casa de praia"
  },
  {
    slug: "atendimento-comercial",
    name: "Atendimento Comercial",
    desc: "Restaurantes, pousadas, hotéis e quiosques — sem parar sua operação.",
    image: "/img/tecnico-desentupimento-residencial-litoral.webp",
    alt: "Atendimento comercial de desentupimento 24h para estabelecimentos comerciais"
  },
  {
    slug: "atendimento-industrial",
    name: "Atendimento Industrial",
    desc: "Hidrojato industrial e sucção de alta capacidade para portos, marinas e indústrias.",
    image: "/img/hidrojateamento-litoral-sp.webp",
    alt: "Hidrojateamento industrial de alta pressão para redes coletoras e indústrias litorâneas"
  },
  {
    slug: "emergencia-24-horas",
    name: "Emergência 24 Horas",
    desc: "Plantão real 24h/7 dias em todo o litoral — resposta em minutos pelo WhatsApp.",
    image: "/img/equipe-desentope-maresias-litoral.webp",
    alt: "Plantão emergencial 24 horas de desentupidora com equipe de prontidão no litoral"
  },
];

export const CITIES = [
  { slug: "peruibe", name: "Peruíbe" },
  { slug: "itanhaem", name: "Itanhaém" },
  { slug: "mongagua", name: "Mongaguá" },
  { slug: "praia-grande", name: "Praia Grande" },
  { slug: "sao-vicente", name: "São Vicente" },
  { slug: "santos", name: "Santos" },
  { slug: "guaruja", name: "Guarujá" },
  { slug: "bertioga", name: "Bertioga" },
  { slug: "sao-sebastiao", name: "São Sebastião" },
  { slug: "sao-sebastiao-sede", name: "São Sebastião (Sede)" },
  { slug: "sao-francisco-da-praia", name: "São Francisco da Praia" },
  { slug: "caraguatatuba", name: "Caraguatatuba" },
  { slug: "ubatuba", name: "Ubatuba" },
  { slug: "cananeia", name: "Cananéia" },
  { slug: "ilha-comprida", name: "Ilha Comprida" },
  { slug: "ilhabela", name: "Ilhabela" },
];

export const REVIEWS = [
  { name: "Sra. Fernanda A.", place: "Maresias, São Sebastião", text: "Chegaram em minha casa de praia em Maresias em menos de 40 minutos, resolveram o esgoto entupido com total profissionalismo." },
  { name: "Síndico Ricardo M.", place: "Enseada, Guarujá", text: "O hidrojateamento no condomínio na Enseada foi impecável. Equipe uniformizada e ágil." },
  { name: "Sr. Paulo H.", place: "Ubatuba", text: "Pousada em Ubatuba com refluxo de esgoto durante o feriado. A Desentope Maresias salvou nossa temporada." },
  { name: "Chef Camila S.", place: "Ilhabela", text: "Restaurante em Ilhabela precisou de limpeza emergencial de caixa de gordura à noite. Rápidos e limpos." },
  { name: "Família Souza", place: "Bertioga", text: "Casa de veraneio em Bertioga com fossa cheia. Trabalho limpo, com nota fiscal e descarte ambiental correto." },
  { name: "Marina L.", place: "Santos", text: "Apartamento em Santos com ralo entupido por areia. Atendimento educado e preço justo." },
];

export const FAQ = [
  { q: "Quanto custa uma desentupidora no litoral de São Paulo?", a: "O valor depende do tipo de serviço, da extensão da rede e do acesso ao imóvel. Fazemos avaliação no local e apresentamos o orçamento antes de iniciar — você só autoriza se concordar. Chame no WhatsApp (13) 99679-9241 para uma estimativa imediata." },
  { q: "Em quanto tempo a equipe chega na minha cidade?", a: "Nossa base fica em Maresias (São Sebastião) e mantemos equipes posicionadas pelo litoral norte, centro e sul. O tempo médio varia de 30 a 90 minutos conforme a cidade — em São Sebastião e região, costuma ser bem menor." },
  { q: "Como prevenir entupimentos na casa de praia?", a: "Use grelhas com tela fina nos ralos, enxágue a areia antes de entrar, nunca despeje óleo na pia e faça um check-up pré-temporada: limpeza de caixa de gordura, verificação de fossa e teste de escoamento antes das férias." },
  { q: "O serviço tem garantia?", a: "Sim. Todos os serviços saem com garantia formal por escrito e nota fiscal. Se o problema retornar dentro do prazo, voltamos sem custo adicional." },
  { q: "A maresia realmente causa entupimentos?", a: "Sim. O aerossol salino corrói tubulações metálicas por dentro, deixando as paredes ásperas — que passam a reter gordura, areia e resíduos. Por isso imóveis à beira-mar entopem mais, mesmo com uso cuidadoso." },
  { q: "Vocês atendem de madrugada, domingos e feriados?", a: "Sim, plantão real 24 horas, 7 dias por semana — incluindo feriados prolongados e alta temporada, quando reforçamos as equipes de plantão no litoral." },
];
